import { render, staticRenderFns } from "./Profiel.vue?vue&type=template&id=169e9a25&scoped=true"
import script from "./Profiel.vue?vue&type=script&lang=js"
export * from "./Profiel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e9a25",
  null
  
)

export default component.exports